import React from "react";
import {
  Button,
  Typography,
  TextField,
  Box,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { useDialogInvokers } from "@tiny/lib";

const RequestTemplateDialogContent = ({ onClose }: { onClose: () => void }) => {
  const requestTemplateEmail = "templates@tinyemail.com";

  return (
    <>
      <DialogContent sx={{ mt: 4 }}>
        <Typography variant="label2R" color="grey.90" paragraph>
          Send your request and details to the email below — we'll help craft a
          custom template just for you.
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
          <TextField
            fullWidth
            value={requestTemplateEmail}
            label="Email Address"
            variant="outlined"
            margin="dense"
            InputProps={{
              readOnly: true,
            }}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined" color="primary">
          Cancel
        </Button>
      </DialogActions>
    </>
  );
};

const RequestCampaignButton = () => {
  const { requestSmallDialog, exitDialog } = useDialogInvokers();

  const handleOpenRequestDialog = () => {
    requestSmallDialog({
      titleProps: {
        children: "Send Custom Template Request",
        variant: "label1R",
      },
      contentProps: {
        dividers: false,
        sx: {
          border: "none",
        },
        children: <RequestTemplateDialogContent onClose={exitDialog} />,
      },
    });
  };

  return (
    <Button
      variant="contained"
      id="add-new-campaign"
      onClick={handleOpenRequestDialog}
    >
      Request a Custom Template
    </Button>
  );
};

export default RequestCampaignButton;
